<p-toast position="top-right"></p-toast>

<div class="login-shell">

  <div class="login-brand">
    <div class="brand-orbs" aria-hidden="true">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>

    <div class="brand-header">
      <div class="brand-logo">
        <img src="assets/manager-favicon.svg" alt="iManager" />
        <span class="brand-name"><span class="brand-i">i</span>Manager</span>
      </div>
    </div>

    <div class="brand-inner">
      <div class="brand-copy">
        <h2 class="brand-title">Gestão de times<br>em tempo real.</h2>
        <p class="brand-subtitle">
          Acompanhe produtividade, colaboradores e hierarquia da sua empresa em um único lugar.
        </p>
      </div>

      <ul class="brand-features">
        <li>
          <div class="feature-icon"><i class="pi pi-users"></i></div>
          <div class="feature-text">
            <strong>Gestão de Colaboradores</strong>
            <span>Times, hierarquia e cargos organizados</span>
          </div>
        </li>
        <li>
          <div class="feature-icon"><i class="pi pi-chart-bar"></i></div>
          <div class="feature-text">
            <strong>Indicadores em Tempo Real</strong>
            <span>Atividade, foco e ociosidade monitorados</span>
          </div>
        </li>
        <li>
          <div class="feature-icon"><i class="pi pi-shield"></i></div>
          <div class="feature-text">
            <strong>Seguro e Confiável</strong>
            <span>Dados protegidos com acesso controlado</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="brand-footer">
      <div class="brand-legal">
        <a href="https://docs.imanagerportal.com/?secao=termos-de-uso" target="_blank" rel="noopener">Termos de Uso</a>
        <span class="brand-legal-dot">·</span>
        <a href="https://docs.imanagerportal.com/?secao=politica-privacidade" target="_blank" rel="noopener">Política de
          Privacidade</a>
      </div>
      <span>© 2026 iManager — Portal de Gestão</span>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="login-card">

      <div class="card-logo-mobile" aria-hidden="true">
        <img src="assets/manager-favicon.svg" alt="iManager" />
      </div>

      <!-- Login form (estado padrão) -->
      <ng-container *ngIf="!showTermosPanel && !showEmpresaPanel">

        <div class="card-headline">
          <h1>Bem-vindo</h1>
          <p>Faça login para acessar o portal.</p>
        </div>

        <form [formGroup]="form" (ngSubmit)="submit()" class="login-form">

          <div class="field-group">
            <label class="field-label" for="identificador">Identificador único</label>
            <div class="form-field"
              [class.invalid]="form.controls.identificador.invalid && (form.controls.identificador.dirty || form.controls.identificador.touched)">
              <div class="input-wrapper">
                <i class="pi pi-user input-icon" aria-hidden="true"></i>
                <input pInputText id="identificador" placeholder="Digite seu identificador único" type="text"
                  formControlName="identificador" autocomplete="username" />
              </div>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label" for="senha">Senha</label>
            <div class="form-field"
              [class.invalid]="form.controls.senha.invalid && (form.controls.senha.dirty || form.controls.senha.touched)">
              <div class="input-wrapper">
                <i class="pi pi-lock input-icon" aria-hidden="true"></i>
                <input pInputText id="senha" placeholder="Digite sua senha" [type]="showPassword ? 'text' : 'password'"
                  formControlName="senha" autocomplete="current-password" />
                <button type="button" class="icon-btn"
                  [attr.aria-label]="showPassword ? 'Esconder senha' : 'Mostrar senha'"
                  (click)="togglePasswordVisibility()">
                  <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="options-row">
            <div class="remember">
              <p-checkbox formControlName="remember" [binary]="true" inputId="remember"></p-checkbox>
              <label for="remember">Lembrar de mim</label>
            </div>
            <a class="forgot" routerLink="/esqueci-senha">Esqueci a senha</a>
          </div>

          <div class="login-error" *ngIf="errorMessage">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <button pButton type="submit" label="Entrar" class="login-btn" [disabled]="form.invalid || loading"
            [loading]="loading" tabindex="0">
          </button>

          <div class="divider-row" role="separator">
            <span>ou</span>
          </div>

          <div class="primeiro-acesso-block">
            <p class="primeiro-acesso-eyebrow">Primeiro acesso?</p>
            <a pButton routerLink="/primeiro-acesso" class="login-btn secondary-btn" label="Criar minha senha"></a>
          </div>

          <div class="legal-links-mobile">
            <a href="https://docs.imanagerportal.com/?secao=termos-de-uso" target="_blank" rel="noopener">Termos de Uso</a>
            <span class="separator">·</span>
            <a href="https://docs.imanagerportal.com/?secao=politica-privacidade" target="_blank" rel="noopener">Política de
              Privacidade</a>
          </div>

        </form>
      </ng-container>

      <!-- Painel de termos pendentes (LGPD-11) -->
      <ng-container *ngIf="showTermosPanel">

        <div class="card-headline">
          <h1>Termos atualizados</h1>
          <p>Nossos termos foram atualizados. Aceite para continuar.</p>
        </div>

        <div class="termos-update-banner">
          <i class="pi pi-info-circle termos-banner-icon" aria-hidden="true"></i>
          <span>Para continuar usando o portal, aceite a nova versão dos nossos termos de uso e política de
            privacidade.</span>
        </div>

        <form [formGroup]="termosForm" (ngSubmit)="aceitarTermosLogin()" class="login-form">

          <div class="termos-checkbox-row">
            <p-checkbox formControlName="termosAceitos" [binary]="true" inputId="termosAceitosLogin">
            </p-checkbox>
            <label for="termosAceitosLogin" class="termos-label">
              Li e aceito os
              <a href="https://docs.imanagerportal.com/?secao=termos-de-uso" target="_blank" rel="noopener noreferrer"
                class="termos-link">Termos de Uso</a>
              e a
              <a href="https://docs.imanagerportal.com/?secao=politica-privacidade" target="_blank" rel="noopener noreferrer"
                class="termos-link">Política de Privacidade</a>
            </label>
          </div>

          <div class="login-error" *ngIf="errorTermos">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorTermos }}</span>
          </div>

          <button pButton type="submit" label="Aceitar" class="login-btn"
            [disabled]="termosForm.invalid || loadingTermos" [loading]="loadingTermos" tabindex="0">
          </button>

          <div class="form-link-row">
            <a class="form-link" (click)="cancelarTermos()" href="javascript:void(0)">
              <i class="pi pi-arrow-left"></i> Voltar ao login
            </a>
          </div>

        </form>
      </ng-container>

      <!-- Desambiguação de empresa (409 EMPRESA_AMBIGUA — F7-00 Fase 4) -->
      <ng-container *ngIf="showEmpresaPanel">

        <div class="card-headline">
          <h1>Selecione a empresa</h1>
          <p>Encontramos mais de uma empresa para este login. Escolha para continuar.</p>
        </div>

        <app-empresa-selecao
          [empresas]="empresasCandidatas"
          [loading]="loadingEmpresa"
          [errorMessage]="errorEmpresa"
          trocarLabel="Voltar e informar a senha novamente"
          (escolher)="confirmarEmpresa($event)"
          (trocar)="trocarEmpresa()"
        ></app-empresa-selecao>

      </ng-container>

    </div>
  </div>

</div>